import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';

@Component({
  selector: 'dialog-add-year',
  templateUrl: './dialog-add-year.component.html',
  styleUrls: ['./dialog-add-year.component.scss']
})
export class DialogAddYearComponent implements OnInit {

  isLoading: boolean = false;
  yearForm: FormGroup;
  year: any = [];
  computationPeriod: any = [];

  constructor(public dialogRef: MatDialogRef<DialogAddYearComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private payrollDefinitionService: PayrollDefinitionService) {
      this.yearForm = this.fb.group({
        id: [0],
        definitionId: [this.data.definitionId, 0],
        year: [null, Validators.required],
        quantity: ['', Validators.required],
        computationPeriod: ['', Validators.required],
        netDays: ['', Validators.required],
        date: ['', Validators.required]
      });
    }

  ngOnInit(): void {
    this.getYear();
    this.getComputationPeriod();
    this.yearForm.patchValue({
      definitionId: this.data.definitionId
    })
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getYear() {
    this.payrollDefinitionService.getYear().subscribe({
      next: res => {
        this.year = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getComputationPeriod() {
    this.payrollDefinitionService.getComputationPeriod().subscribe({
      next: res => {
        this.computationPeriod = res;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  save() {
    this.isLoading = true;
    if (this.yearForm.invalid) {
      Object.keys(this.yearForm.controls).forEach(controlName => {
        this.yearForm.get(controlName)?.markAsTouched();
      });
      this.isLoading = false;
      return;
    }

    this.payrollDefinitionService.createUpdateYear(this.yearForm.value).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close();
        window.location.reload();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}
